import React, { useEffect } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Grid, InputAdornment, OutlinedInput, Typography } from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import { useDispatch, useSelector } from 'store';
import { getFriends, filterFriends } from 'store/slices/user';
import PlayerCell from 'views/components/playerCell.component';
import { useParams } from 'react-router-dom';

// assets
import { IconSearch } from '@tabler/icons';
import useGroups from 'hooks/useGroups';
import useLeagues from 'hooks/useLeagues';

// ==============================|| SOCIAL PROFILE - FRIENDS ||============================== //

const PlayersTab = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { groupId } = useParams();
    // const [friends, setFriends] = React.useState([]);
    const userState = useSelector((state) => state.user);
    const { groupInfo } = useGroups();

    const friends = groupInfo?.users;
    let friendsResult = <></>;
    if (friends) {
        friendsResult = friends.map((friend, index) => (
            <Grid key={index} item>
                <MainCard elevation={2}>
                    <Grid item sx={{ width: '280px' }}>
                        <PlayerCell user={friend?.user} mt={0.1} />
                    </Grid>
                    {/* </Grid> */}
                </MainCard>
            </Grid>
        ));
    }

    const [search, setSearch] = React.useState('');
    const handleSearch = async (event) => {
        const newString = event?.target.value;
        setSearch(newString);

        if (newString) {
            dispatch(filterFriends(newString));
        } else {
            dispatch(getFriends());
        }
    };

    return (
        <MainCard
            data-id="groups-PlayersTab"
            title={
                <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
                    <Grid item>
                        <Typography variant="h3">
                            Players
                            <Typography variant="h3" component="span" sx={{ color: theme.palette.grey[300], fontWeight: 500 }}>
                                ({groupInfo?.group.num_members})
                            </Typography>
                        </Typography>
                    </Grid>
                    <Grid item>
                        <OutlinedInput
                            size="small"
                            id="input-search-user-profile"
                            placeholder="Search"
                            value={search}
                            onChange={handleSearch}
                            startAdornment={
                                <InputAdornment position="start">
                                    <IconSearch stroke={1.5} size="16px" />
                                </InputAdornment>
                            }
                        />
                    </Grid>
                </Grid>
            }
        >
            <Grid container direction="row" spacing={gridSpacing}>
                {friendsResult}
            </Grid>
        </MainCard>
    );
};

export default PlayersTab;
